{
  "页面暂时无法加载，请稍后重试。": "This page could not be loaded. Please try again later.",
  "连接失败": "Connection failed",
  "无法连接服务器，请检查网络后重试。": "Unable to connect to the server. Check your connection and try again.",
  "登录已失效，请重新登录。": "Your session has expired. Please sign in again.",
  "当前账号没有访问权限。": "Your account does not have permission to access this content.",
  "页面或资源不存在，可能已被移除。": "This page or resource does not exist or has been removed.",
  "请求过于频繁，请稍后重试。": "Too many requests. Please try again later.",
  "服务暂时不可用，请稍后重试。": "The service is temporarily unavailable. Please try again later.",
  "重新登录": "Sign in again"
}
